import "babel-polyfill";
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from './store';
import DateFilter from './filters/DateFilter';
import DatetimeFilter from './filters/DatetimeFilter';
import AppointmentDurationFilter from './filters/AppointmentDurationFilter';
import ShowCallInfoResultStateFilter from './filters/ShowCallInfoResultStateFilter';
import ShowCallInfoResultCustomerFriendlyFilter from './filters/ShowCallInfoResultCustomerFriendlyFilter';
import AppointmentDateFilter from './filters/AppointmentDateFilter';
import ItemInspectionTypeFilter from './filters/ItemInspectionTypeFilter';
import ItemServiceEngineerFilter from './filters/ItemServiceEngineerFilter';
import ItemSupplementaryTestFilter from './filters/ItemSupplementaryTestFilter';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'toastr/build/toastr.min.css';
import * as toastr from "toastr";
import { FormHelper } from "@/helpers";
import { ConfigService, SecurityService } from './services';
import { AppContainer } from './app/AppContainer';
import { TYPES } from './app/types';
const BootstrapDatePicker = require("vue-bootstrap-datetimepicker");

const configService: ConfigService = AppContainer.get<ConfigService>(TYPES.Services.ConfigService);
configService.LoadConfig()
  .then(() => {
    var currentURL = window.location.hostname.toLowerCase();
    let branding = "";
    switch (true) {
      case configService.Config.BrandingURLBES !== "" && currentURL.includes("britishengineeringservices.co.uk"):
        branding = "bes";
      case configService.Config.BrandingURLVulcan !== "" && currentURL.includes("vulcaninspectionservices.co.uk"):
        branding = "vis";
      default:
        branding = "bes";
    }

    import(`./css/bootstrap.${branding}.min.css`);

    // Configure toastr
    toastr.options.timeOut = 5000;
    toastr.options.tapToDismiss = true;
    toastr.options.closeButton = true;
    toastr.options.progressBar = true;

    // Configure Vue
    Vue.use(Vuelidate);
    Vue.use(BootstrapVue);
    Vue.use(BootstrapDatePicker);
    Vue.config.productionTip = false;
    Vue.filter('date', DateFilter);
    Vue.filter('datetime', DatetimeFilter);
    Vue.filter('AppointmentDuration', AppointmentDurationFilter);
    Vue.filter('ShowCallInfoResultState', ShowCallInfoResultStateFilter);
    Vue.filter('ShowCallInfoResultCustomerFriendlyFilter', ShowCallInfoResultCustomerFriendlyFilter);
    Vue.filter('AppointmentDate', AppointmentDateFilter);
    Vue.filter('ItemInspectionType', ItemInspectionTypeFilter);
    Vue.filter('ItemServiceEngineer', ItemServiceEngineerFilter);
    Vue.filter('ItemSupplementaryTest', ItemSupplementaryTestFilter)
    Vue.prototype.Helpers = {
      FormHelper
    };

    new Vue({
      validations: {},
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  });